export default {
    getPatientEvidenceHistoryDataTableOptions: state => state.patientEvidenceHistoryDataTableOptions,
    getPatientEvidenceHistoryRowActions: state => state.patientEvidenceHistoryRowActions,
    getPatientEvidenceHistoryActions: state => state.patientEvidenceHistoryActions,
    getPatientEvidenceHistoryHeaderFields: state => state.patientEvidenceHistoryHeaderFields,
    getPatientEvidenceHistorySearchFields: state => state.patientEvidenceHistorySearchFields
}
